import { userPreferencesApiConnector } from 'apiConnector/userPreferences/userPreferences';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, mergeMap, timeout, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  userPreferencesSaveFailed,
  userPreferencesSaveSucceed,
  userPreferencesSaveTimeouted,
} from 'state/userPreferences/userPreferences.action';
import type { UserPreferences } from 'state/userPreferences/userPreferences.model';

export function resetUserPreferences(timeoutInMillis: number = 60000, appScheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { selectors: { getUserPreferencesAll }, httpClient }) =>
    action$.pipe(
      ofType('USER_PREFERENCES_SPMTABS_RESET'),
      withLatestFrom(state$),
      mergeMap(([_, state]) => {
        const userPreferences: UserPreferences = getUserPreferencesAll(state);

        return userPreferencesApiConnector(httpClient)
          .saveUserPreferences({ ...userPreferences, tabsOrder: null })
          .pipe(
            mergeMap(() => of(userPreferencesSaveSucceed(userPreferences))),
            catchError(() => of(userPreferencesSaveFailed())),
            timeout({ each: timeoutInMillis, with: () => of(userPreferencesSaveTimeouted()), scheduler: appScheduler }),
          );
      }),
    );
}
